import ProjectCard from '@/components/ProjectCard';
import { projects } from '@/data/projects';

// Art 列表页：项目顺序由 src/data/projects.js 中的数组顺序决定。
export default function ArtIndexPage() {
  return (
    <main>
      <section className="section art-index-page">
        <div className="art-index-intro">
          <p className="section-title">Art</p>
          <div className="art-index-headline-row">
            <h1 className="art-index-heading">Projects</h1>
            <p className="art-index-copy">
              A growing sequence of moving image, garment, performance, and text. Each project keeps
              its own tempo, its own surface, its own statement.
            </p>
          </div>
        </div>

        <div className="art-project-list">
          {projects.map((project, index) => (
            // 第一个项目沿用旧站 featured 样式，并作为首屏关键图片优先加载。
            <ProjectCard
              key={project.slug}
              project={project}
              featured={index === 0}
              priority={index === 0}
            />
          ))}
        </div>
      </section>
    </main>
  );
}
